"use strict";

import sidebarToggle from './modules/sidebar-toggle.mjs';
import tcNeosElementsBootstrap from 'tc-neos-elements-bootstrap';
import tcNeosElements from 'tc-neos-elements'; // do not remove this line, even if it is not used (Google Maps call initMap() from this file)
import vehicleCatalog from 'tc-website-vehicle-catalog';
import partnerOfferPricing from './modules/partner-offer-pricing.mjs';
import showroomProductSheetModal from './modules/showroom-product-sheet-modal.mjs';
import swissNumberInput from './modules/swiss-number-input.mjs';

// Expose tcNeosElementsBootstrap globally for use in other modules
window.tcNeosElementsBootstrap = tcNeosElementsBootstrap;
const PRICE_MODE_STORAGE_KEY = 'tcPartnerCataloguePriceMode';

document.addEventListener('DOMContentLoaded', () => {
    sidebarToggle.init();
    vehicleCatalog.init(document);
    initCataloguePriceModeSegments();
    swissNumberInput.init(document);
    partnerOfferPricing.init(document);
    showroomProductSheetModal.init(document);

    window.addEventListener('hashchange', () => {
        tcNeosElementsBootstrap.anchor();
    });
});

function initCataloguePriceModeSegments() {
    const segmentsRoot = document.querySelector('[data-catalog-price-mode-segments]');
    if (!(segmentsRoot instanceof HTMLElement)) {
        return;
    }

    const form = document.getElementById('partner-catalog-filters-form');
    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    const hiddenPriceMode = form.querySelector('#catalog-price-mode');
    if (!(hiddenPriceMode instanceof HTMLInputElement)) {
        return;
    }

    const buttons = segmentsRoot.querySelectorAll('[data-catalog-price-mode]');
    buttons.forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) {
            return;
        }
        button.addEventListener('click', () => {
            const nextMode = button.getAttribute('data-catalog-price-mode') === 'purchase' ? 'purchase' : 'catalog';
            applyPriceModeUi(segmentsRoot, hiddenPriceMode, nextMode);
            persistPriceModePreference(nextMode);
            if (typeof form.requestSubmit === 'function') {
                form.requestSubmit();
            } else {
                form.submit();
            }
        });
    });

    const queryMode = readPriceModeFromQuery();
    if (queryMode !== null) {
        applyPriceModeUi(segmentsRoot, hiddenPriceMode, queryMode);
        persistPriceModePreference(queryMode);
        return;
    }

    const storedMode = readStoredPriceModePreference();
    if (storedMode !== null && storedMode !== hiddenPriceMode.value) {
        applyPriceModeUi(segmentsRoot, hiddenPriceMode, storedMode);
        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
        } else {
            form.submit();
        }
    }
}

function applyPriceModeUi(segmentsRoot, hiddenInput, mode) {
    const normalizedMode = mode === 'purchase' ? 'purchase' : 'catalog';
    hiddenInput.value = normalizedMode;

    const buttons = segmentsRoot.querySelectorAll('[data-catalog-price-mode]');
    buttons.forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) {
            return;
        }
        const isActive = button.getAttribute('data-catalog-price-mode') === normalizedMode;
        button.classList.toggle('tc-partner-catalog-toolbar__segment--active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
}

function readPriceModeFromQuery() {
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('priceMode')) {
        return null;
    }

    const value = searchParams.get('priceMode');
    return normalizePriceModeValue(value);
}

function readStoredPriceModePreference() {
    try {
        const fromSession = normalizePriceModeValue(window.sessionStorage.getItem(PRICE_MODE_STORAGE_KEY));
        if (fromSession !== null) {
            return fromSession;
        }
        return normalizePriceModeValue(window.localStorage.getItem(PRICE_MODE_STORAGE_KEY));
    } catch (_error) {
        return null;
    }
}

function persistPriceModePreference(value) {
    const normalizedMode = value === 'purchase' ? 'purchase' : 'catalog';
    try {
        window.sessionStorage.setItem(PRICE_MODE_STORAGE_KEY, normalizedMode);
        window.localStorage.setItem(PRICE_MODE_STORAGE_KEY, normalizedMode);
    } catch (_error) {
        // Ignore storage write failures (private mode, disabled storage, etc.).
    }
}

function normalizePriceModeValue(value) {
    if (value === null || value === undefined) {
        return null;
    }

    const normalized = String(value).trim().toLowerCase();
    if (normalized === 'purchase' || normalized === 'achat') {
        return 'purchase';
    }
    if (normalized === 'catalog' || normalized === 'catalogue' || normalized === '') {
        return 'catalog';
    }

    return null;
}
